export default __webpack_public_path__ + "static/media/slider-cia-2.1023dfa9.jpg";